import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { BUDGET_LINE_ITEMS } from "./apiRoutes";

const mutateUpdateMonthlyDistribution = async ({
  lineItemId,
  budgetId,
  data,
}: {
  lineItemId: string;
  budgetId: string;
  data: FieldValues;
}) => {
  return await axiosAuth.put(
    `${BUDGET_LINE_ITEMS(budgetId)}/${lineItemId}/monthly-distribution`,
    data
  );
};

const useUpdateMonthlyDistributionMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      lineItemId: string;
      budgetId: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateMonthlyDistribution,
    ...queryParams,
  });

export default useUpdateMonthlyDistributionMutation;
